"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _webcom = _interopRequireDefault(require("webcom/webcom"));

var DataSync = _interopRequireWildcard(require("./util/DataSync"));

var _cache = _interopRequireDefault(require("./util/cache"));

var Log = _interopRequireWildcard(require("./util/Log"));

var _Room = _interopRequireDefault(require("./Room"));

var _Device = _interopRequireDefault(require("./Device"));

var _constants = require("./util/constants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var initializing = false;
/**
 * User informations
 * @public
 */

var User =
/*#__PURE__*/
function () {
  /**
   * Create a user
   * @param {Webcom/api.DataSnapshot|object} snapData The data snapshot
   * @access protected
   */
  function User(snapData, userId) {
    _classCallCheck(this, User);

    var values = Object.assign({}, snapData.val());
    /**
     * User's unique id
     * @type {string}
     */
    // this.uid = snapData.name();

    this.uid = userId;
    /**
     * User's display name
     * @type {string}
     */

    this.name = values.name;
    /**
     * User's status
     * @type {string}
     */

    this.status = values.status;
    /**
     * User's last know connection ts
     * @type {number}
     */

    this.lastSeen = values.lastSeen;
    /**
     * Indicates if the user is an anonymous user
     * @type {boolean}
     */

    this.anonymous = /^anonymous/.test(values.provider); // TODO #Feat: Add 'extra' property for unrestricted additional information ?
  }
  /**
   * Invite a user directly. This will create a new Room, log you in it & invite the user.
   * @param {string} [message] a message to add to the invite
   * @return {Promise<{room: Room, invite: Invite}, Error>}
   */


  _createClass(User, [{
    key: "invite",
    value: function invite(message) {
      var _this = this;

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can invite another User.'));
      }

      return _Room.default.create("".concat(_cache.default.user.uid, "-").concat(this.uid)).then(function (room) {
        return room.invite([_this], null, message);
      }).then(function (data) {
        return {
          room: data.room,
          invite: data.invites[0]
        };
      }).catch(Log.r('User~invite'));
    }
    /**
     * List Users's devices. Only for current user.
     * @access protected
     * @return {Promise<Device[], Error>}
     */

  }, {
    key: "devices",
    value: function devices() {
      return DataSync.list("_/devices/".concat(this.uid), _Device.default);
    }
    /**
     * Init the current user
     * @access protected
     * @param {json} auth The user's identity (webcom JSON structure)
     * @param {string} [name] The user's display name
     * @returns {Promise<User, Error>}
     */

  }], [{
    key: "init",
    value: function init(auth, name) {
      var id1 = Math.floor(Math.random() * 1000);
      var id2 = Math.floor(Math.random() * 1000);
      var uid = "".concat(id1, "/").concat(id2, "/").concat(auth.uid);
      var userUid = "".concat(id1, ":").concat(id2, ":").concat(auth.uid); // const uid = auth.uid;

      if (!initializing) {
        initializing = true;
        var d = {
          status: _constants.CONNECTED,
          lastSeen: DataSync.ts(),
          provider: auth.provider
        };

        if (name) {
          Object.assign(d, {
            name: name
          });
        }

        var deviceId = _webcom.default.INTERNAL.PersistentStorage.get(uid);

        return DataSync.update("users/".concat(uid), d) // Register current device
        .then(function () {
          var deviceMetadata = {
            status: _constants.CONNECTED,
            sdk: {
              reach: SDK_VERSION,
              // eslint-disable-line no-undef
              webcom: _webcom.default.SDK_VERSION
            },
            userAgent: navigator.userAgent
          };
          _cache.default.userAgent = deviceMetadata.userAgent;

          if (deviceId) {
            return DataSync.update("_/devices/".concat(uid, "/").concat(deviceId), deviceMetadata);
          }

          return DataSync.push("_/devices/".concat(uid), deviceMetadata);
        }) // Save device
        .then(function (deviceRef) {
          if (!deviceId) {
            deviceId = deviceRef.name();

            _webcom.default.INTERNAL.PersistentStorage.set(uid, deviceId);
          }

          _cache.default.device = deviceId;
        }) // Add onDisconnect actions
        .then(function () {
          // Disconnect device
          DataSync.onDisconnect("_/devices/".concat(uid, "/").concat(deviceId, "/status")).set(_constants.NOT_CONNECTED); // Update user status

          DataSync.onDisconnect("users/".concat(uid)).update({
            status: _constants.NOT_CONNECTED,
            lastSeen: DataSync.ts()
          });
        }) // Get user
        // .then(() => User.get(uid))
        .then(function () {
          return User.get(userUid);
        }).then(function (user) {
          initializing = false;
          return user;
        }).catch(function (e) {
          Log.e(e);
          initializing = false;
          return Promise.reject(e);
        });
      } // return User.get(uid);


      return User.get(userUid);
    }
    /**
     * Disconnect the current user
     * @access protected
     * @param {User} user The current user
     * @returns {Promise}
     */

  }, {
    key: "disconnect",
    value: function disconnect(user) {
      // Cancel onDisconnect
      // due to the problem of long list, uids have a : instead of /
      var userUid = user.uid.replace(/:/g, '/'); // DataSync.onDisconnect(`_/devices/${user.uid}/${cache.device}/status`).cancel();
      // DataSync.onDisconnect(`users/${user.uid}`).cancel();

      DataSync.onDisconnect("_/devices/".concat(userUid, "/").concat(_cache.default.device, "/status")).cancel();
      DataSync.onDisconnect("users/".concat(userUid)).cancel();

      if (user.anonymous) {
        return DataSync.remove("_/devices/".concat(userUid)).then(function () {
          return DataSync.get("_/invites/".concat(userUid));
        }).then(function (invites) {
          var inviteIds = [];
          invites.forEach(function (invite) {
            inviteIds.push(invite.name());
          });
          return Promise.all(inviteIds.map(function (inviteId) {
            return DataSync.remove("_/invites/".concat(userUid, "/").concat(inviteId));
          }));
        }) // TODO refactor data model for invites so we can delete _/invites/${user.uid}
        // .then(() => DataSync.remove(`_/invites/${user.uid}`))
        .then(function () {
          return DataSync.remove("users/".concat(userUid));
        }).then(function () {
          _webcom.default.INTERNAL.PersistentStorage.remove(userUid);
        }).catch(Log.r('User#anonymous_disconnect'));
      }

      return DataSync.set("_/devices/".concat(userUid, "/").concat(_cache.default.device, "/status"), _constants.NOT_CONNECTED).then(function () {
        return DataSync.get("_/devices/".concat(userUid));
      }).then(function (devices) {
        // Only change user's status if no other device connected
        var hasConnectedDevices = devices.forEach(function (device) {
          return new RegExp("^".concat(_constants.CONNECTED, "$")).test(device.val().status);
        });

        if (!hasConnectedDevices) {
          return DataSync.update("users/".concat(userUid), {
            status: _constants.NOT_CONNECTED
          });
        }

        return true;
      }).catch(Log.r('User#disconnect'));
    }
    /**
     * Get a user by its uid
     * @access private
     * @param {string} uid The user's uid
     * @returns {Promise<User, Error>}
     */

  }, {
    key: "get",
    value: function get(uid) {
      // due to the problem of long list, uids have a : instead of /
      var userUid = uid.replace(/:/g, '/');
      return DataSync.get("users/".concat(userUid)) // .then(snapData => snapData ? new User(snapData, newUid) : null)
      .then(function (snapData) {
        return snapData ? new User(snapData, uid) : null;
      }).catch(Log.r('User#get'));
    }
  }]);

  return User;
}();

exports.default = User;